import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, withKeys as _withKeys, createSlots as _createSlots, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-59e33fc8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "guideline" }
const _hoisted_2 = { class: "action" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "years" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "btns" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Expand to Model ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Save")
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Submit ")
const _hoisted_10 = { class: "content" }
const _hoisted_11 = { class: "box" }
const _hoisted_12 = { class: "table" }
const _hoisted_13 = { class: "kufri" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "Kufri", -1))
const _hoisted_15 = /*#__PURE__*/_createTextVNode("Take Guideline")
const _hoisted_16 = /*#__PURE__*/_createTextVNode("Batch Input")
const _hoisted_17 = {
  key: 0,
  class: "total"
}
const _hoisted_18 = { class: "total-header" }
const _hoisted_19 = { style: {"white-space":"nowrap","display":"flex"} }
const _hoisted_20 = ["onClick"]
const _hoisted_21 = ["onClick"]
const _hoisted_22 = { class: "header" }
const _hoisted_23 = { class: "scroll-box" }
const _hoisted_24 = { class: "scroll-content" }
const _hoisted_25 = { class: "cell" }
const _hoisted_26 = { class: "cell" }
const _hoisted_27 = { class: "month-cell" }
const _hoisted_28 = { class: "total-list" }
const _hoisted_29 = { class: "header" }
const _hoisted_30 = { class: "scroll-box" }
const _hoisted_31 = { class: "scroll-content" }
const _hoisted_32 = { class: "cell" }
const _hoisted_33 = { class: "cell" }
const _hoisted_34 = {
  key: 0,
  class: "month-cell"
}
const _hoisted_35 = { class: "title" }
const _hoisted_36 = { class: "top c-0088C6 font-bold font-14" }
const _hoisted_37 = { class: "title" }
const _hoisted_38 = { class: "top c-0088C6 font-bold font-14" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "top",
    style: {"color":"#BFBFBF"}
  }, [
    /*#__PURE__*/_createElementVNode("i", {
      class: "font_family icon-a-takeproposal-icon font-12",
      style: {"font-weight":"normal"}
    }),
    /*#__PURE__*/_createElementVNode("span", { style: {"font-weight":"normal"} }, "Click to take proposal data")
  ])
], -1))
const _hoisted_40 = { class: "title" }
const _hoisted_41 = { class: "top" }
const _hoisted_42 = { class: "title month-header" }
const _hoisted_43 = {
  key: 0,
  class: "top"
}
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Take Proposal", -1))
const _hoisted_45 = ["onClick"]
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "font_family icon-a-takeproposal-icon font-12 icon-forecast" }, null, -1))
const _hoisted_47 = /*#__PURE__*/_createTextVNode(" Forecast")
const _hoisted_48 = [
  _hoisted_46,
  _hoisted_47
]
const _hoisted_49 = { class: "month-year" }
const _hoisted_50 = { key: 0 }
const _hoisted_51 = { style: {"color":"#CCC"} }
const _hoisted_52 = { key: 1 }
const _hoisted_53 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Breadcrumb = _resolveComponent("Breadcrumb")!
  const _component_cascade_selector = _resolveComponent("cascade-selector")!
  const _component_a_badge = _resolveComponent("a-badge")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_SpreadJsDialog = _resolveComponent("SpreadJsDialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_Breadcrumb, {
        dataSource: [{name: 'Bottom Up'}],
        class: "breadcrumb-planning"
      }),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_cascade_selector, {
          onUpdate: _ctx.handleUpdate,
          type: "bottomUp"
        }, null, 8, ["onUpdate"]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.years, (year) => {
              return (_openBlock(), _createElementBlock("div", {
                key: year.year,
                class: "year-box"
              }, [
                _createElementVNode("span", {
                  class: _normalizeClass(["year-item", {'active' : _ctx.currentYear === year.year}]),
                  onClick: ($event: any) => (_ctx.handleChooseYear(year.year))
                }, [
                  _createVNode(_component_a_badge, {
                    dot: !year.buSaveStatus
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", null, _toDisplayString(year.year), 1)
                    ]),
                    _: 2
                  }, 1032, ["dot"])
                ], 10, _hoisted_5)
              ]))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_a_checkbox, {
              checked: _ctx.expandAllStatus,
              "onUpdate:checked": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.expandAllStatus) = $event)),
              class: "mr-20",
              disabled: _ctx.tableData.length <= 0
            }, {
              default: _withCtx(() => [
                _hoisted_7
              ]),
              _: 1
            }, 8, ["checked", "disabled"]),
            (_ctx.$btnPermissions('p-bu03', '/glAndBu'))
              ? (_openBlock(), _createBlock(_component_a_button, {
                  key: 0,
                  type: "primary",
                  class: "mr-20",
                  disabled: _ctx.tableData.length <= 0,
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleSaveOrSubmit('save')))
                }, {
                  default: _withCtx(() => [
                    _hoisted_8
                  ]),
                  _: 1
                }, 8, ["disabled"]))
              : _createCommentVNode("", true),
            (_ctx.$btnPermissions('p-bu02', '/glAndBu'))
              ? (_openBlock(), _createBlock(_component_a_button, {
                  key: 1,
                  type: "primary",
                  class: "mr-20",
                  disabled: _ctx.tableData.length <= 0,
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handleSaveOrSubmit('submit')))
                }, {
                  default: _withCtx(() => [
                    _hoisted_9
                  ]),
                  _: 1
                }, 8, ["disabled"]))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableData, (make, makeIndex) => {
          return (_openBlock(), _createElementBlock("div", {
            class: _normalizeClass(["result bg-fff", make.make + makeIndex]),
            key: make.planningId
          }, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", null, [
                    _hoisted_14,
                    _createVNode(_component_a_select, {
                      value: make.viewKufriVersion,
                      "onUpdate:value": ($event: any) => ((make.viewKufriVersion) = $event),
                      onChange: (kufri) => _ctx.handleKufriChange(kufri, makeIndex, make)
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(make.kufirVersions, (version) => {
                          return (_openBlock(), _createBlock(_component_a_select_option, {
                            key: version,
                            vlaue: version
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(version), 1)
                            ]),
                            _: 2
                          }, 1032, ["vlaue"]))
                        }), 128))
                      ]),
                      _: 2
                    }, 1032, ["value", "onUpdate:value", "onChange"]),
                    _createVNode(_component_a_button, {
                      type: "primary",
                      class: "ml-20",
                      onClick: ($event: any) => (_ctx.handleTakeGuideline(make))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_15
                      ]),
                      _: 2
                    }, 1032, ["onClick"])
                  ]),
                  _createElementVNode("div", null, [
                    _createVNode(_component_a_button, {
                      type: "primary",
                      class: "mr-12",
                      onClick: ($event: any) => (_ctx.handleBatchInput(make, makeIndex))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_16
                      ]),
                      _: 2
                    }, 1032, ["onClick"])
                  ])
                ]),
                (make.total)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                      _createElementVNode("div", _hoisted_18, [
                        _createElementVNode("div", _hoisted_19, [
                          (!make.totalExpand)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: "expand",
                                onClick: ($event: any) => (make.totalExpand = true)
                              }, "+", 8, _hoisted_20))
                            : (_openBlock(), _createElementBlock("div", {
                                key: 1,
                                class: "expand",
                                onClick: ($event: any) => (make.totalExpand = false)
                              }, "-", 8, _hoisted_21)),
                          _createElementVNode("span", _hoisted_22, _toDisplayString(make.make) + " Total", 1),
                          _createElementVNode("div", _hoisted_23, [
                            _createElementVNode("div", _hoisted_24, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.seasonTotal, (item) => {
                                return (_openBlock(), _createElementBlock("span", {
                                  key: item.title
                                }, [
                                  _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.number2Fixed(make.total[item.title].releasePoint)), 1),
                                  _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.number2Fixed(make.total[item.title].buPoint)), 1)
                                ]))
                              }), 128)),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.months, (item) => {
                                return (_openBlock(), _createElementBlock("span", {
                                  key: item.title
                                }, [
                                  _createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.number2Fixed(make.total[item.title].buPoint)), 1)
                                ]))
                              }), 128))
                            ])
                          ])
                        ])
                      ]),
                      _withDirectives(_createElementVNode("div", _hoisted_28, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(make.totalVOList, (item) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "item",
                            key: item.bu
                          }, [
                            _createElementVNode("span", _hoisted_29, _toDisplayString(item.bu), 1),
                            _createElementVNode("div", _hoisted_30, [
                              _createElementVNode("div", _hoisted_31, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.seasonTotal, (season) => {
                                  return (_openBlock(), _createElementBlock("span", {
                                    key: season.title
                                  }, [
                                    _createElementVNode("span", _hoisted_32, _toDisplayString(_ctx.number2Fixed(item[season.title].releasePoint)), 1),
                                    _createElementVNode("span", _hoisted_33, _toDisplayString(_ctx.number2Fixed(item[season.title].buPoint)), 1)
                                  ]))
                                }), 128)),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.months, (month) => {
                                  return (_openBlock(), _createElementBlock("span", {
                                    key: month.title
                                  }, [
                                    (item[month.title])
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_34, _toDisplayString(_ctx.number2Fixed(item[month.title].buPoint)), 1))
                                      : _createCommentVNode("", true)
                                  ]))
                                }), 128))
                              ])
                            ])
                          ]))
                        }), 128))
                      ], 512), [
                        [_vShow, make.totalExpand]
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createVNode(_component_a_table, {
                  class: "data-table",
                  scroll: { x: 1500, y: 500 },
                  columns: _ctx.tableColumns,
                  "data-source": make.detailVOList,
                  pagination: false,
                  rowKey: "id",
                  expandedRowKeys: _ctx.expandedRowKeysList[makeIndex],
                  onExpand: (expand, record) => _ctx.handleExpand(expand, record, makeIndex),
                  rowClassName: (record, index) => (record.brand ? 'hasBrand' : null)
                }, _createSlots({
                  bu: _withCtx(() => [
                    _createElementVNode("div", _hoisted_35, [
                      _createElementVNode("div", _hoisted_36, _toDisplayString(make.make), 1)
                    ])
                  ]),
                  typeClass: _withCtx(() => [
                    _createElementVNode("div", _hoisted_37, [
                      _createElementVNode("div", _hoisted_38, _toDisplayString(_ctx.scenarioName), 1)
                    ])
                  ]),
                  nstGroup: _withCtx(() => [
                    _hoisted_39
                  ]),
                  _: 2
                }, [
                  _renderList(_ctx.seasons, (season) => {
                    return {
                      name: season.slot,
                      fn: _withCtx(() => [
                        _createElementVNode("div", _hoisted_40, [
                          _createElementVNode("div", _hoisted_41, _toDisplayString(_ctx.currentYear) + "-" + _toDisplayString(season.title), 1)
                        ])
                      ])
                    }
                  }),
                  _renderList(_ctx.months, (month) => {
                    return {
                      name: month.title,
                      fn: _withCtx(() => [
                        _createElementVNode("div", _hoisted_42, [
                          (month.actualStatus[makeIndex])
                            ? (_openBlock(), _createElementBlock("div", _hoisted_43, "Actual"))
                            : (_openBlock(), _createBlock(_component_a_tooltip, {
                                key: 1,
                                placement: "top"
                              }, {
                                title: _withCtx(() => [
                                  _hoisted_44
                                ]),
                                default: _withCtx(() => [
                                  _createElementVNode("div", {
                                    onClick: ($event: any) => (_ctx.handleForecast(month.text, month.title, makeIndex, make)),
                                    class: "cursor-pointer",
                                    style: {"position":"relative"}
                                  }, _hoisted_48, 8, _hoisted_45)
                                ]),
                                _: 2
                              }, 1024)),
                          _createElementVNode("div", _hoisted_49, _toDisplayString(_ctx.currentYear) + "-" + _toDisplayString(month.text), 1)
                        ])
                      ])
                    }
                  }),
                  _renderList(_ctx.months, (month) => {
                    return {
                      name: month.text,
                      fn: _withCtx(({record}) => [
                        (record[month.title] && month.actualStatus[makeIndex])
                          ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                              _createElementVNode("span", _hoisted_51, _toDisplayString(_ctx.number2Fixed(record[month.title].buPoint)), 1)
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_52, [
                              _createElementVNode("div", null, [
                                (!record[month.title].editing || _ctx.lockStatus)
                                  ? (_openBlock(), _createElementBlock("span", {
                                      key: 0,
                                      class: _normalizeClass(["cell-span", {'edited-span': record[month.title].edited, 'empty-span': !month.actualStatus[makeIndex] && !record[month.title].buPoint && (record[month.title].rtVolume > 0) && record[month.title].buPoint !== 0}]),
                                      onClick: ($event: any) => (_ctx.handleClickCell($event, record[month.title], record, month.actualStatus[makeIndex]))
                                    }, [
                                      _createElementVNode("span", null, _toDisplayString(_ctx.number2Fixed(record[month.title].buPoint)), 1)
                                    ], 10, _hoisted_53))
                                  : (_openBlock(), _createBlock(_component_a_input, {
                                      key: 1,
                                      value: record[month.title].buPoint,
                                      "onUpdate:value": ($event: any) => ((record[month.title].buPoint) = $event),
                                      type: "number",
                                      onFocus: ($event: any) => (_ctx.handleFocus(record, month.title)),
                                      onBlur: ($event: any) => (_ctx.handleBlur(record, month.title, make.detailVOList)),
                                      onKeyup: _withKeys(_ctx.handleEnter, ["enter"]),
                                      onInput: ($event: any) => (record[month.title].buPoint=record[month.title].buPoint.replace(/([0-9]+\.[0-9]{15})[0-9]*/, '$1'))
                                    }, null, 8, ["value", "onUpdate:value", "onFocus", "onBlur", "onKeyup", "onInput"]))
                              ])
                            ]))
                      ])
                    }
                  })
                ]), 1032, ["columns", "data-source", "expandedRowKeys", "onExpand", "rowClassName"])
              ])
            ])
          ], 2))
        }), 128))
      ])
    ]),
    _createVNode(_component_SpreadJsDialog, {
      spreadVisible: _ctx.spreadVisible,
      spreadData: _ctx.spreadData,
      actuals: _ctx.actuals,
      year: _ctx.currentYear,
      makeName: _ctx.currentMakeName,
      onUpdate: _ctx.handleSpreadJsUpdate,
      onClose: _ctx.handleCloseSpreadJsDialog,
      field: "buPoint"
    }, null, 8, ["spreadVisible", "spreadData", "actuals", "year", "makeName", "onUpdate", "onClose"])
  ], 64))
}